import Wil, { LogEvent, WilEventTaget, IntersectionHelper } from "./main/index";
import WilClickEventTaget from "./main/click";
export { LogEvent, WilEventTaget, WilClickEventTaget, IntersectionHelper };
export default Wil;
